import ChatSearchInput from '@/components/molecules/ChatSearchInput';
import React, { FC, useState } from 'react';

interface EmojiPickerModalProps {
  emojiList: { name: string; jsCode: string; code: string }[];
  handleEmojiClick: (jsCode: string) => void;
}

const EmojiPickerModal: FC<EmojiPickerModalProps> = ({
  emojiList,
  handleEmojiClick,
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <>
      <div className='p-1 flex flex-row rounded-sm mr-2 mt-3'>
        <ChatSearchInput
          type='text'
          className=''
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          placeholder='Search emojis'
          leftIcon={
            <svg
              width='13'
              height='13'
              viewBox='0 0 13 13'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M11.8125 11.5391L8.67188 8.39844C9.35156 7.57812 9.72656 6.52344 9.72656 5.375C9.72656 2.70312 7.52344 0.5 4.85156 0.5C2.15625 0.5 0 2.70312 0 5.375C0 8.07031 2.17969 10.25 4.85156 10.25C5.97656 10.25 7.03125 9.875 7.875 9.19531L11.0156 12.3359C11.1328 12.4531 11.2734 12.5 11.4375 12.5C11.5781 12.5 11.7188 12.4531 11.8125 12.3359C12.0469 12.125 12.0469 11.7734 11.8125 11.5391ZM1.125 5.375C1.125 3.3125 2.78906 1.625 4.875 1.625C6.9375 1.625 8.625 3.3125 8.625 5.375C8.625 7.46094 6.9375 9.125 4.875 9.125C2.78906 9.125 1.125 7.46094 1.125 5.375Z'
                fill='#656971'
              />
            </svg>
          }
        />
      </div>
      <div className='flex flex-wrap p-4'>
        {emojiList
          .filter(item => {
            return searchQuery.toLowerCase() === ''
              ? item
              : item.name.toLowerCase().includes(searchQuery);
          })
          .map((emoji: any, index: any) => {
            return (
              <div
                onClick={() => handleEmojiClick(emoji.jsCode)}
                className={`px-2 py-1 hover:bg-gray-200 rounded-md cursor-pointer`}
                key={index}
              >
                {emoji.jsCode}
              </div>
            );
          })}
      </div>
    </>
  );
};

export default EmojiPickerModal;
